import { Icon } from '@manychat/manyui'

export enum AiImproverGoal {
  CUSTOM = 'new_goal',
  MAKE_MORE_MARKETING = 'more_market',
  FRIENDLY = 'friendly',
  SIMPLIFY = 'simplify',
  MORE_ENGAGING = 'more_engaging',
}

export enum Step {
  WRITE_TEXT = 'write_text',
  CHOOSE_GOAL = 'choose_goal',
  CHOOSE_IMPROVEMENT = 'choose_improvement',
  RATE_RESULT = 'rate_result',
  PROMOTE_ADDON = 'promote_addon',
}

export enum OptionType {
  BUTTON = 'button',
  INPUT = 'input',
}

export interface ButtonConfig {
  type: OptionType.BUTTON
  label: () => string
  keyCode: string
  icon: keyof typeof Icon
}

export interface InputConfig {
  type: OptionType.INPUT
  label: () => string
  keyCode: string
  validation: {
    min: number
    max: number
  }
}

export type OptionControlConfig = ButtonConfig | InputConfig

export interface Goal {
  value: AiImproverGoal
  config: OptionControlConfig
}

export enum RateType {
  DISLIKE = 'dislike',
  LIKE = 'like',
  LOVE = 'love',
}

export enum RateFeatureType {
  TEXT_IMPROVER = 'ai_improve_node_text',
  AI_ASSISTANT = 'ai_assistant',
}
